import { defineComponent as r, createElementBlock as l, openBlock as o, normalizeStyle as s, renderSlot as t } from "vue";
const d = /* @__PURE__ */ r({
  __name: "SidebarGroup",
  props: {
    level: {}
  },
  setup(a) {
    return (e, n) => (o(), l("ul", {
      class: "sidebar-group sidebar-indent-nested",
      style: s({ "--scalar-sidebar-level": e.level })
    }, [
      t(e.$slots, "default")
    ], 4));
  }
});
export {
  d as default
};
